module.exports = __webpack_public_path__ + "static/robe_of_the_archmagi-mtg_clb-ffe621e614cc8e128ba1404a56ada57e.jpg";